import { render, staticRenderFns } from "./AutoDetect.vue?vue&type=template&id=10831468&scoped=true&"
import script from "./AutoDetect.vue?vue&type=script&lang=js&"
export * from "./AutoDetect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10831468",
  null
  
)

export default component.exports